import React, { useState } from 'react'
import { BannerMockTicket } from 'components'
import SouSouPromo from './SouSouPromo'
import { getSouSouUrl } from './souSouUrl'
import './index.styl'

// Home page promo row (SOU-22.1): Sou-Sou banner on the left, the existing TicketLyfe banner (unchanged) on the right.
// Without a valid REACT_APP_SOU_SOU_URL (missing configuration, not a product flag) only the existing banner renders, as before.
const HomePromoRow = () => {
  const [closed, setClosed] = useState(false)
  // an unset or invalid URL (not https, or http outside localhost) means: no Sou-Sou half, the page is as before
  const souSouUrl = getSouSouUrl()
  if (closed) return null

  if (!souSouUrl) return <BannerMockTicket />

  return (
    <div className='homePromoRow'>
      <SouSouPromo url={souSouUrl} />
      <div className='homePromoRowTicketLyfe'>
        <BannerMockTicket inRow onClose={() => setClosed(true)} />
      </div>
    </div>
  )
}

export default HomePromoRow
